const counters = document.querySelectorAll('[js-counter]')
const speed = 400

const options = {
  root: document,
  rootMargin: '0px',
  threshold: 0.25
}

if (counters) {
  for(const counter of counters) {
    const animate = () => {
      const value = +counter.dataset.value
      const data = +counter.innerText

      const time = value / speed
      if (data < value) {
        counter.innerText = Math.ceil(data + time)
        setTimeout(animate, 1)
      } else {
        counter.innerText = value
      }
    }
    const observer = new IntersectionObserver((entries, observer) => {
      if (entries[0].isIntersecting) {
        animate()
        observer.disconnect()
      }
    }, options)

    observer.observe(counter)
  }
}


